<template>
    <Tab :title="$trad.brand.navigation.eStore">
        <loader :loading="true" v-if="loading"></loader>
        <div class="form-group row">
            <label class="col-4 col-form-label label">{{ $t("brand.brandHiddenPrice") }}</label>
            <div class="col-8 choicesHiddenPrice">
                <span :class="{ active: !datas.isPriceShown }" @click="datas.isPriceShown = false;"> {{ $t("brand.brandHiddenNo") }}</span>
                <span :class="{ active: datas.isPriceShown }" @click="datas.isPriceShown = true;"> {{ $t("brand.brandHiddenYes") }}</span>
            </div>
        </div>
        <br />
        <SelectBloc v-model="datas.currency.id" :required="true" :options="currencies" :label="$t('brand.currency')">
            <template slot="noneValue">
                <option :value="undefined">{{ $t("brand.errorCurrency") }}</option>
            </template>
        </SelectBloc>
        <br />
        <CheckboxGroupBloc
            v-model="datas.orderShippingMethods"
            :name="'shippingMethods'"
            :label="$t('brand.shippingMethods')"
            :options="shippingMethods"
        ></CheckboxGroupBloc>
    </Tab>
</template>

<script>
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import FormSectionTitle from "@/components/ui/Form/FormSectionTitle";
import SelectBloc from "@/components/ui/Form/SelectBloc";
import CheckboxGroupBloc from "@/components/ui/Form/CheckboxGroupBloc";
import Tab from "@/components/admin/brand/tabs/Tab";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "EditBrandEStore",
    mixins: [TryLoad],
    model: {
        prop: "datas",
        event: "input"
    },
    components: {
        loader,
        FormSectionTitle,
        SelectBloc,
        CheckboxGroupBloc,
        Tab
    },
    props: {
        datas: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions("currency", {
            populateCurrencies: "populate"
        }),
        ...mapActions("shippingMethod", {
            populateShippingMethods: "populate"
        })
    },
    computed: {
        ...mapGetters("currency", {
            currencies: "currencies"
        }),
        ...mapGetters("shippingMethod", {
            shippingMethods: "shippingMethods"
        })
    },
    created() {
        this.tryLoad(() => Promise.all([this.populateShippingMethods(), this.populateCurrencies()]));
    }
};
</script>

<style lang="scss" scoped>
.choicesHiddenPrice {
    span {
        display: inline-block;
        cursor: pointer;
        border: 1px gray solid;
        text-align: center;
        padding: 5px 10px;
        margin: 0px 5px;
        opacity: 0.4;
        transition: all 0.3s ease;
        &:hover,
        &.active {
            opacity: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditBrandEStore.vue?ac7f69c2